import type { FC } from "react";
import { Breakpoint, useMediaQuery } from "@stubhub/broadway-providers";
import { HeadingLevel, Layout } from "@viagogo/core/ui";
import { Content } from "src/shared/components/content";
import { useAnalyticsEvents } from "src/shared/utils/analyticsevent/analyticsevent-batcher";
import { usePageEvents } from "src/shared/utils/pageevents";
import { CustomerCharter } from "src/website-apps/responsive/stubhub-about-us/components/viagogo/CustomerCharter";
import { DescriptionAndVideo } from "src/website-apps/responsive/stubhub-about-us/components/viagogo/DescriptionAndVideo";
import { Details } from "src/website-apps/responsive/stubhub-about-us/components/viagogo/Details";
import { Guarantee } from "src/website-apps/responsive/stubhub-about-us/components/viagogo/Guarantee";
import { useAboutUsPageModelData } from "src/website-apps/responsive/stubhub-about-us/hooks/useAboutUsPageModelData";
import { LazyFooter } from "src/website-apps/shared/components/footer";
import { HeaderConfiguration } from "src/website-apps/shared/components/header";
import { TitleBannerViagogo } from "src/website-apps/shared/components/TitleBanner/TitleBanner";

export const App: FC = () => {
  usePageEvents();
  useAnalyticsEvents();
  const isPhone = !useMediaQuery(Breakpoint.Tablet);
  const model = useAboutUsPageModelData();

  return (
    <HeadingLevel>
      <Layout
        header={<HeaderConfiguration.Simple />}
        body={
          <>
            <TitleBannerViagogo isPhone={isPhone} title={<Content id="cid$#3029959#" />} />
            <DescriptionAndVideo />
            <Details />
            <CustomerCharter />
            <Guarantee />
          </>
        }
        footer={
          <LazyFooter
            companyLinks={model.footer.companyLinks}
            supportLinks={model.footer.supportLinks}
            getLocationSettingsUrl={model.footer.getLocationSettingsUrl}
          />
        }
      />
    </HeadingLevel>
  );
};
